"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AWSUploader = exports.AWS = void 0;
var axios_1 = require("axios");
var uss_vod_js_sdk_1 = require("uss-vod-js-sdk");
var utils_1 = require("uss-vod-js-sdk/lib/src/utils");
var report_1 = require("./report");
var types_1 = require("./types");
var utils_2 = require("./utils");
var AWS = /** @class */ (function () {
    function AWS(options) {
        this.mediaUrl = options.authorization;
        this.coverUrl = options.coverToken;
        this.domain = options.domain;
        this.vid = options.vid;
        this.reportOption = {
            country: options.country,
            env: options.env,
            biz: options.biz,
            sdkVersion: options.sdkVersion,
            serviceId: options.serviceId,
            serviceIndex: options.serviceIndex,
            vid: options.vid
        };
    }
    AWS.prototype.upload = function (params) {
        return new AWSUploader(__assign(__assign({ mediaUrl: this.mediaUrl, coverUrl: this.coverUrl }, params), { vid: this.vid, domain: this.domain, report: new report_1.Report(this.reportOption) }));
    };
    return AWS;
}());
exports.AWS = AWS;
var AWSUploader = /** @class */ (function () {
    function AWSUploader(_a) {
        var mediaFile = _a.mediaFile, coverFile = _a.coverFile, mediaType = _a.mediaType, mediaUrl = _a.mediaUrl, coverUrl = _a.coverUrl, vid = _a.vid, domain = _a.domain, report = _a.report;
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/ban-types
        this.eventMap = new Map();
        this.report = report;
        this.domain = domain;
        this.cancelToken = axios_1.default.CancelToken.source();
        this.$ = axios_1.default.create();
        this.$.interceptors.response.use(function (response) { return response; }, function (error) {
            var _a, _b, _c, _d, _e, _f, _g;
            if (axios_1.default.isCancel(error)) {
                return Promise.reject(new utils_1.Error({
                    code: uss_vod_js_sdk_1.ErrorCode.UserCancel,
                    message: 'User cancel',
                    error: error
                }));
            }
            if ((_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) {
                return Promise.reject(new utils_1.Error({
                    code: (_d = (_c = error === null || error === void 0 ? void 0 : error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.code,
                    message: (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.data) === null || _f === void 0 ? void 0 : _f.message,
                    error: error,
                    httpCode: (_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.status
                }));
            }
            return Promise.reject(error);
        });
        var promises = new Array(4).fill(Promise.resolve(null));
        if (mediaFile) {
            this.fsize = mediaFile.size;
            var key_1 = mediaType === types_1.MediaType.video ? "".concat(vid, ".ori.mp4") : "".concat(vid, ".ori.aac");
            promises[0] = this.$.put(mediaUrl, mediaFile, {
                headers: {
                    'Content-Type': types_1.ContentTypeHeader[mediaType]
                },
                cancelToken: this.cancelToken.token,
                onUploadProgress: function (progressEvent) {
                    _this.emit(types_1.UploaderEvents.mediaProgress, {
                        total: progressEvent.total,
                        loaded: progressEvent.loaded,
                        percent: parseFloat((progressEvent.loaded / progressEvent.total).toFixed(2))
                    });
                }
            })
                .then(function () {
                var uploadResponse = _this.genUploadResponse(vid, key_1);
                _this.emit(types_1.UploaderEvents.mediaUpload, uploadResponse);
                return uploadResponse;
            })
                .catch(function (error) {
                var _a, _b, _c;
                var actionId = uss_vod_js_sdk_1.ErrorCode.PublishResultVideoFailed;
                if (axios_1.default.isCancel((error === null || error === void 0 ? void 0 : error.error) || error))
                    actionId = uss_vod_js_sdk_1.ErrorCode.UserCancel;
                _this.report
                    .FileTransferEvent({
                    actionId: actionId,
                    code: (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : 0
                })
                    .report();
                _this.cancel();
                throw error;
            });
            promises[2] = (0, utils_2.getFileMd5)(mediaFile);
        }
        if (coverFile) {
            if (!mediaFile)
                this.fsize = coverFile.size;
            var key_2 = "".concat(vid, ".ori.jpg");
            promises[1] = this.$.put(coverUrl, coverFile, {
                headers: {
                    'Content-Type': types_1.ContentTypeHeader['image']
                },
                cancelToken: this.cancelToken.token,
                onUploadProgress: function (progressEvent) {
                    _this.emit(types_1.UploaderEvents.coverProgress, {
                        total: progressEvent.total,
                        loaded: progressEvent.loaded,
                        percent: parseFloat((progressEvent.loaded / progressEvent.total).toFixed(2))
                    });
                }
            })
                .then(function () {
                var uploadResponse = _this.genUploadResponse(vid, key_2);
                _this.emit(types_1.UploaderEvents.coverUpload, uploadResponse);
                return uploadResponse;
            })
                .catch(function (error) {
                var _a, _b, _c;
                var actionId = uss_vod_js_sdk_1.ErrorCode.PublishResultCoverFailed;
                if (axios_1.default.isCancel((error === null || error === void 0 ? void 0 : error.error) || error)) {
                    actionId = uss_vod_js_sdk_1.ErrorCode.UserCancel;
                }
                _this.report
                    .FileTransferEvent({
                    actionId: actionId,
                    code: (_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code) !== null && _c !== void 0 ? _c : 0
                })
                    .report();
                _this.cancel();
                throw error;
            });
            promises[3] = (0, utils_2.getFileMd5)(coverFile);
        }
        //@ts-ignore
        this.donePromise = Promise.all(promises);
    }
    AWSUploader.prototype.cancel = function () {
        this.cancelToken.cancel();
    };
    AWSUploader.prototype.done = function () {
        return __awaiter(this, void 0, void 0, function () {
            var startTime, _a, video, cover, videoMd5, coverMd5, result, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        startTime = Date.now();
                        return [4 /*yield*/, this.donePromise];
                    case 1:
                        _a = _b.sent(), video = _a[0], cover = _a[1], videoMd5 = _a[2], coverMd5 = _a[3];
                        this.report
                            .FileTransferEvent({
                            actionId: uss_vod_js_sdk_1.ErrorCode.Success,
                            code: 0,
                            sdkCode: 0,
                            cost: Date.now() - startTime,
                            extendId: (video === null || video === void 0 ? void 0 : video.extendId) || (cover === null || cover === void 0 ? void 0 : cover.extendId),
                            fsize: this.fsize
                        })
                            .report();
                        result = {
                            video: video,
                            cover: cover
                        };
                        if (videoMd5) {
                            result.video.md5 = videoMd5;
                        }
                        if (coverMd5) {
                            result.cover.md5 = coverMd5;
                        }
                        return [2 /*return*/, result];
                    case 2:
                        error_1 = _b.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    AWSUploader.prototype.genUploadResponse = function (vid, key) {
        var url = this.domain + '/' + key;
        return {
            url: url,
            etag: vid,
            extendId: vid
        };
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    AWSUploader.prototype.on = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName) || new Set();
        callbacks.add(callback);
        this.eventMap.set(eventName, callbacks);
    };
    // eslint-disable-next-line @typescript-eslint/ban-types
    AWSUploader.prototype.off = function (eventName, callback) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.delete(callback);
            if (callbacks.size === 0) {
                this.eventMap.delete(eventName);
            }
        }
    };
    AWSUploader.prototype.emit = function (eventName, params) {
        var callbacks = this.eventMap.get(eventName);
        if (callbacks) {
            callbacks.forEach(function (callback) {
                callback(params);
            });
        }
    };
    return AWSUploader;
}());
exports.AWSUploader = AWSUploader;
